import script from "./TillsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TillsView.vue?vue&type=script&setup=true&lang=js"

import "./TillsView.vue?vue&type=style&index=0&id=22e0af24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22e0af24"]])

export default __exports__